import { useState } from "react";
import PropTypes from "prop-types";
import { BbotButton, BbotModal, Input } from "top-component-library";
import { FormRow } from "../styles";

// Mirrors confirmDeactivate()'s $mdDialog.prompt(). Unlike DeleteStationDialog, the typed
// name is NOT checked here - the server verifies it against customer_name and rejects with
// an error if it doesn't match, exactly like legacy.
const DeactivateCustomerDialog = ({ onClose, onConfirm }) => {
  const [typedName, setTypedName] = useState("");
  const [deactivating, setDeactivating] = useState(false);

  const handleConfirm = async () => {
    setDeactivating(true);
    const succeeded = await onConfirm(typedName);
    setDeactivating(false);
    if (succeeded) onClose();
  };

  return (
    <BbotModal
      title="Are you sure you want to deactivate this customer?"
      visible
      onCancel={onClose}
      footer={[
        <BbotButton key="cancel" onClick={onClose}>
          Never mind, go back!
        </BbotButton>,
        <BbotButton
          key="confirm"
          type="primary"
          danger
          loading={deactivating}
          disabled={!typedName}
          onClick={handleConfirm}
        >
          Confirm
        </BbotButton>,
      ]}
    >
      <FormRow>
        <label htmlFor="deactivate-customer-confirm-name">
          Type in the customer name to confirm (the name visible for patrons):
        </label>
        <Input
          id="deactivate-customer-confirm-name"
          placeholder="Bbot Restaurant"
          value={typedName}
          onChange={(event) => setTypedName(event.target.value)}
        />
      </FormRow>
    </BbotModal>
  );
};

DeactivateCustomerDialog.propTypes = {
  onClose: PropTypes.func.isRequired,
  onConfirm: PropTypes.func.isRequired,
};

export default DeactivateCustomerDialog;
